{
  "features-majority-account-no-ssn": {
    "meta": {
      "title": "Banca móvil sin SSN - MAJORITY",
      "description": "Estamos haciendo la banca más accesible. Abre una cuenta con un pasaporte, matrícula consular u otra ID emitida por el gobierno si no tienes un SSN."
    },
    "hero": {
      "title": "Banca móvil sin SSN",
      "body": "Estamos haciendo la banca más accesible. Abre una cuenta con un pasaporte, matrícula consular u otra ID emitida por el gobierno si no tienes un SSN.",
      "cta": "Registrarse",
      "features": [],
      "disclaimer": "*La app de MAJORITY brinda los servicios bancarios a través de Axiom Bank, N.A., miembro de la FDIC.",
      "circle": "Sin necesidad de SSN"
    },
    "no_ssn_content_box": {
      "tagline": "Cuenta de MAJORITY",
      "title": "Obtén una cuenta sin SSN",
      "body": "Independientemente del estatus migratorio, todos merecen acceso a servicios financieros básicos. Obtén una cuenta y una tarjeta de débito Visa® incluso sin un SSN. Simplemente verifica tu identidad con una ID emitida por el gobierno, como un pasaporte o matrícula consular.",
      "canvas": "Sin necesidad de SSN",
      "cta": "Comenzar"
    },
    "compare_fees_content_box": {
      "tagline": "Cuenta de MAJORITY",
      "title": "¿No tienes SSN? No hay problema",
      "body": "Estos son algunos de los documentos que puedes utilizar para verificar tu identidad:\n* Número de Seguro Social (SSN)\n* Número de Identificación Personal del Contribuyente (ITIN)\n* Pasaporte válido\n* Matrícula consular mexicana\n* Licencia de conducir\n* ID del estado\n* ID de inmigración o permiso de residencia\n* Otra ID con foto emitida por el gobierno",
      "cta": "Registrarse"
    },
    "citizen_content_box": {
      "title": "¿Necesito ser ciudadano estadounidense para abrir una cuenta?",
      "body": "No. Creemos en la personalidad por encima de la nacionalidad, por lo que le damos la bienvenida a ciudadanos y no ciudadanos por igual. Simplemente verifica tu información con una ID emitida por el gobierno para desbloquear todos los beneficios y ahorros que ofrece nuestra app de banca móvil todo en uno. Abrir una cuenta no tiene costos adicionales ni requiere de citas especiales en persona.",
      "cta": "Comenzar"
    }
  }
  
}